<template>
  <!-- 篮球队排名 -->
  <div class="sub-page">
    <div class="bask-rank">
      <div class="rank-tab">
        <div class="tab-list">
          <div class="tab-item" v-for="(item, index) in rankTabList" :key="index" @click="handleTab(item,index)">
          <div>{{ item.name }}</div>
          <div class="line" v-show="rankIndex==index"></div>
          </div>
        </div>
        <div class="row row-title">
          <div class="col-1">排名</div>
          <div class="col-2">球队</div>
          <div class="col-3">胜</div>
          <div class="col-4">负</div>
          <div class="col-5">胜场差</div>
          <div class="col-6">胜率(%)</div>
          <div class="col-7">积分</div>
          <div class="col-8">返10场</div>
          <div class="col-9">连胜/败</div>
          <div class="col-10">场均得分</div>
          <div class="col-11">场均失分</div>
          <div class="col-12">净胜分</div>
          <div class="col-13">主场</div>
          <div class="col-14">客场</div>
        </div>
        <div class="row" v-for="item,index in rowList" :key="index" :class="index%2==1?'active-bg':''">
          <div class="col-1">{{index+1}}</div>
          <div class="col-2">{{item.name}}</div>
          <div class="col-3">胜</div>
          <div class="col-4">负</div>
          <div class="col-5">胜场差</div>
          <div class="col-6">胜率(%)</div>
          <div class="col-7">积分</div>
          <div class="col-8">返10场</div>
          <div class="col-9">连胜/败</div>
          <div class="col-10">场均得分</div>
          <div class="col-11">场均失分</div>
          <div class="col-12">净胜分</div>
          <div class="col-13">主场</div>
          <div class="col-14">客场</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasketballRank',
  props: {},
  data() {
    return {
      rankTabList: [
        {
          name: '积分榜',
        },
        {
          name: '球员数据榜',
        },
        {
          name: '球队数据榜',
        },
        {
          name: '球员纪录',
        },
        {
          name: '球队纪录',
        },
      ],
      rankIndex:0,
      rowList:[
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
        {name:'球队名字'},
      ]
    }
  },
  components: {},
  mounted() {},
  methods: {
    handleTab(item,index){
      this.rankIndex=index
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page {
  width: 100%;
  background-color: #f7f7f7;
  padding-top: 20px;
  padding-bottom: 30px;
  .bask-rank {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    .tab-list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 30px;
      .tab-item{
        margin-right: 20px;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        cursor: pointer;
        .line{
          width: 100%;
          height: 4px;
          background-color: #AA1F23;
          margin-top: 8px;
        }
      }
    }
    .row{
      display:  flex;
      justify-content: space-between;
      height: 60px;
      line-height: 60px;
      padding: 0 30px;
      .col-1{
        width: 5%;
      }
      .col-2{
        width: 10%;
      }
    }
    .active-bg{
      background-color: #E9E9E9;
    }
    .row-title{
      background-color: #000000;
      color: #FFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballRank.vue